export const LOAN_TYPES = ["Home Loan", "Personal Loan", "Business Loan", "LAP", "Credit Card", "Vehicle Loan"];

export const STAGES = ["Lead Created", "Documents Pending", "Login Done", "Under Process", "Approved", "Disbursed", "Rejected"];

export const STATUS_BADGE = {
  "Lead Created": "bg-slate-100 text-slate-700 border-slate-300",
  "Documents Pending": "bg-amber-50 text-amber-700 border-amber-200",
  "Login Done": "bg-blue-50 text-blue-700 border-blue-200",
  "Under Process": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Approved": "bg-teal-50 text-teal-700 border-teal-200",
  "Disbursed": "bg-emerald-100 text-emerald-700 border-emerald-300 font-semibold",
  "Rejected": "bg-rose-50 text-rose-700 border-rose-200",
};

export const STAGE_DOT = {
  "Lead Created": "bg-slate-400",
  "Documents Pending": "bg-amber-500",
  "Login Done": "bg-blue-500",
  "Under Process": "bg-indigo-500",
  "Approved": "bg-teal-500",
  "Disbursed": "bg-emerald-500",
  "Rejected": "bg-rose-500",
};

export const ROLE_LABELS = {
  admin: "Admin",
  master_dsa: "Master DSA",
  dsa: "DSA",
  agent: "Agent",
  sales_manager: "Sales Manager",
  partner: "Partner",
};

export function formatINR(n) {
  if (n == null || isNaN(n)) return "\u20b90";
  return "\u20b9" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(iso) {
  if (!iso) return "\u2014";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function exportCSV(rows, filename) {
  if (!rows || !rows.length) return;
  const keys = Object.keys(rows[0]);
  const csv = [keys.join(",")].concat(
    rows.map((r) => keys.map((k) => `"${String(r[k] ?? "").replace(/"/g, '""')}"`).join(","))
  ).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const inputCls = "w-full px-3.5 py-2 rounded-lg border border-slate-300 bg-white text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 text-sm transition-all";
export const labelCls = "block text-xs font-semibold text-slate-700 mb-1.5 uppercase tracking-wider";
export const btnPrimary = "px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white font-medium text-sm transition-all shadow-sm active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50";
export const btnSecondary = "px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-800 font-medium text-sm transition-all border border-slate-200 flex items-center justify-center gap-2";
